export default function TrustSection() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 text-center mb-12">
          Come funziona Itaobuy Spreadsheet?
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-5 gap-6 mb-16">
          {[
            { step: '01', title: 'Trova una spreadsheet aggiornata', desc: 'Cerca le migliori risorse disponibili online' },
            { step: '02', title: 'Analizza prodotti disponibili', desc: 'Esplora le categorie e i prodotti elencati' },
            { step: '03', title: 'Confronta prezzi e caratteristiche', desc: 'Valuta le opzioni con dati chiari' },
            { step: '04', title: 'Scegli prodotti interessanti', desc: 'Seleziona cio che fa per te' },
            { step: '05', title: 'Procedi tramite il servizio principale', desc: 'Acquista in modo semplice e veloce' },
          ].map((item, idx) => (
            <div key={idx} className="relative">
              <div className="text-center">
                <div className="w-14 h-14 mx-auto rounded-full bg-primary-500 text-white flex items-center justify-center font-heading text-xl font-bold mb-4">
                  {item.step}
                </div>
                <h4 className="font-heading text-base font-semibold text-foreground-900 mb-2">{item.title}</h4>
                <p className="text-foreground-500 text-xs leading-relaxed">{item.desc}</p>
              </div>
              {idx < 4 && (
                <div className="hidden md:block absolute top-7 left-[calc(50%+32px)] w-[calc(100%-64px)] h-px bg-background-200"></div>
              )}
            </div>
          ))}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
          {[
            { value: '60+', label: 'Guide SEO' },
            { value: '100+', label: 'Keyword Pages' },
            { value: '2026', label: 'Aggiornamenti continui' },
            { value: 'Italia', label: 'Focus mercato italiano' },
          ].map((stat, idx) => (
            <div key={idx} className="text-center p-6 rounded-xl bg-background-100/70 border border-background-200/50">
              <div className="font-heading text-3xl md:text-4xl font-bold text-primary-600 mb-1">{stat.value}</div>
              <div className="text-foreground-500 text-sm">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}